import { defineFeature } from "../../app/feature";
import { AttributeTracePage } from "./AttributeTracePage";
import { EnvironmentsPage } from "./EnvironmentsPage";
import { SnapshotBrowserPage } from "./SnapshotBrowserPage";

/** Maximo environment browser (task 4070.7): profile versions, every profiled section, custom
 * extensions, coverage, Base Pack discrepancies, and the trace of one target attribute to the
 * metadata that governs it. Owned by the maximo-intelligence lane. */
export default defineFeature({
  id: "environment-profiles",
  title: "Environment profiles",
  routes: [
    { path: "/environment-profiles", Component: EnvironmentsPage },
    { path: "/environment-profiles/snapshots/:snapshotId", Component: SnapshotBrowserPage },
    {
      path: "/environment-profiles/snapshots/:snapshotId/objects/:objectname/attributes/:attributename",
      Component: AttributeTracePage,
    },
  ],
  nav: {
    label: "Environment profiles",
    path: "/environment-profiles",
    section: "Environment Profiles",
    order: 10,
  },
  // Customer configuration is shown only to roles that may read engagements (MER-SEC-003); the
  // API enforces the same permission, and the only writes (a Base Pack comparison, a discrepancy
  // decision) need engagement.manage or mapping.certify.
  permissions: ["engagement.read"],
});
